<h1 style="padding-top: 2rem;">Step 2: Only Go to Bed When Sleepy</h1>
<div class="row">
    <div class="col-md-6" style="font-family: Karla; font-size : 14px;">
        <p>
            This rule is related to the first, and it simply states that you should not go to bed unless you are sleepy.
        </p>
        <br>

        <p>

            It is important to adhere to the following principle: <b>“if you’re not sleepy at the scheduled bedtime, you
            should
            not go to bed yet”.</b> Stay up a little longer, and only go to bed when you are actually feeling that you could
            fall asleep.
        </p>
        <br>


        <p>

            This step not only helps with building up your <b>“sleep pressure”</b>, but can reduce frustration while feeling
            anxious about not being able to fall asleep while in bed.

        </p>
        <br>

        <p>

            Finally, going to bed when you are not sleepy will provide your brain the wrong message. We need to
            condition
            your brain to promote sleep when you are in bed, which leads us right to the third step.
        </p>
        <br>


    </div>
    <div class="col-md-6">
        <div class="row justify-content-around">
            <img src="/assets/actionplan-step2-1.png" style="width: 70%;" />
            <q style="width: 90%;">
                If you’re not sleepy at the scheduled bedtime, you should not go to bed yet
            </q>
        </div>
    </div>
</div>
<style>
    q::before {
        color: #055D9D;
        display: block;
        content: open-quote;
        font-size: 2rem;
    }

    q {
        quotes: '\201c''\201d';
        font-size: 20px;
        font-family: 'Karla';
        font-weight: bold;
        line-height: 32px;
        padding-left: 2rem
    }

    q::after {
        color: #055D9D;
        display: block;
        content: close-quote;
        font-size: 2rem;
    }
</style>